import { NgModule } from '@angular/core';
import { ExternalNavigationModalComponent } from './external-navigation-modal.component';
import { EdAssistUIButtonModule } from '@edassist-ui/button';
import { EdAssistUIButtonContainerModule } from '@edassist-ui/button-container';
import { EdAssistUIModalModule } from '@edassist-ui/modal';
import { EdAssistUIParagraphModule } from '@edassist-ui/paragraph';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [ExternalNavigationModalComponent],
	imports: [
		CommonModule,
		EdAssistUIButtonModule,
		EdAssistUIButtonContainerModule,
		EdAssistUIModalModule,
		EdAssistUIParagraphModule
	],
	exports: [ExternalNavigationModalComponent]
})
export class ExternalNavigationModalModule {}
